import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMoveBounce12 from './IconMoveBounce12';
import IconMoveBounce16 from './IconMoveBounce16';
import IconMoveBounce20 from './IconMoveBounce20';
import IconMoveBounce24 from './IconMoveBounce24';
import IconMoveBounce32 from './IconMoveBounce32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMoveBounce = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMoveBounce12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMoveBounce16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMoveBounce20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMoveBounce24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMoveBounce32 {...props} />}
        </span>
    );
};
IconMoveBounce.displayName = 'FondueIconMoveBounce';

export default memo(IconMoveBounce);
